<script>
    import {PAYMENT_TYPES} from "../lib/constants";
    import PriceControl from "../components/controls/PriceControl.svelte";
    import CaretIcon from "../components/icons/CaretIcon.svelte";

    export let shift;

    let showData = false;

    const incomes = {
        arrivals: "Arrivals",
        departures: "Departures",
        transfers: "transfers",
        tours: "Tours",
        locals: "Locals"
    };

    const setTotals = () => {
        shift.total_incomes = 0;

        shift.incomes.map(item => {
            item.total_price = 0;
            item.total_vehicle_price = 0;
            item.total_commission_price = 0;

            Object.keys(incomes).map(key => {
                let price = parseFloat(item[`${key}_price`] || 0);
                let vehicle_price = parseFloat(item[`${key}_vehicle_price`] || 0);
                let commission_price = price - vehicle_price;

                item[`${key}_commission_price`] = commission_price > 0 ? commission_price.toFixed(2) : null;

                item.total_price += price;
                item.total_vehicle_price += vehicle_price;
                item.total_commission_price += commission_price;
            });

            shift.total_incomes += item.total_price;

            item.total_price = item.total_price > 0 ? item.total_price.toFixed(2) : null;
            item.total_vehicle_price = item.total_vehicle_price > 0 ? item.total_vehicle_price.toFixed(2) : null;
            item.total_commission_price = item.total_commission_price > 0 ? item.total_commission_price.toFixed(2) : null;
        });
    }

    $: setTotals();
</script>

<div class="legend py-1 mb-2">
    <button class="btn no-outline d-flex align-items-center justify-content-between w-100 px-0 fs-6"
            on:click={() => showData = !showData}>
        Incomes
        <span class="d-flex align-items-center gap-2">
            {#if shift.total_incomes > 0}
                <span class="text-gray">{shift.total_incomes}€</span>
            {/if}
            <CaretIcon size="18" strokeWidth="2" expanded={showData}/>
        </span>
    </button>
</div>
{#if showData}
    <table class="table totals mb-4">
        <tbody>
        {#each shift.incomes as item}
            <tr>
                <th>{PAYMENT_TYPES[item.payment_type]}</th>
                <th>No</th>
                <th>Total</th>
                <th>Vehicle</th>
                <th>Comm</th>
            </tr>
            {#each Object.keys(incomes) as key}
                <tr>
                    <td>{incomes[key]}</td>
                    <td>
                        <PriceControl cssClass="small-input" bind:value={item[key]}
                                      onChange={setTotals}/>
                    </td>
                    <td>
                        <PriceControl cssClass="small-input" bind:value={item[`${key}_price`]}
                                      onChange={setTotals}/>
                    </td>
                    <td>
                        <PriceControl cssClass="small-input" bind:value={item[`${key}_vehicle_price`]}
                                      onChange={setTotals}/>
                    </td>
                    <td class="no-input">{item[`${key}_commission_price`] || ''}</td>
                </tr>
            {/each}
            <tr>
                <td>Total</td>
                <td></td>
                <td class="no-input">{item.total_price || ''}</td>
                <td class="no-input">{item.total_vehicle_price || ''}</td>
                <td class="no-input">{item.total_commission_price || ''}</td>
            </tr>
            <tr>
                <td colspan="5">&nbsp;</td>
            </tr>
        {/each}
        </tbody>
    </table>
{/if}